// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__lXTut","card":"SuccessPage_card__4AHM8","h2":"SuccessPage_h2__f4p+o","p":"SuccessPage_p__ojnTM","link":"SuccessPage_link__FC3ZC"};